import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import ButtonWithPermissions from '../../components/buttonWithPermissions/buttonWithPermissions'
import Page from '../../components/page/page'
import PageHeader from '../../components/page/pageHeader'
import { CustomIframe } from '../../components/shared/customIframe/customIframe'
import { hasResource } from '../../helpers/permissionsHelper'
import { NonAuthRoutes } from '../../model'
import { Resources } from '../../model/RBAC/constants'
import { getActiveBalanceZone, getActiveCompany, getCustomerDomain } from '../../redux'

export interface InvoiceCyclesPageProps {}

export const InvoiceCyclesPage: React.FC<InvoiceCyclesPageProps> = props => {
  const history = useHistory()
  const [t] = useTranslation(['invoiceCyclesPage'])
  const apiSuffixUrl = 'https://' + getCustomerDomain()

  let activeCompany = getActiveCompany()
  let activeBalanceZone = getActiveBalanceZone()
  const [routeLocal, setRouteLocal] = useState(apiSuffixUrl + '/Facturacion/EjecucionFacturacion')

  useEffect(() => {
    call()
  }, [activeCompany, activeBalanceZone])

  const call = async () => {
    setRouteLocal(
      `${apiSuffixUrl}/company/index/${activeCompany?.id}?idBalanceZone=${activeBalanceZone?.id}&company=${activeCompany?.description}&balanceZoneDescription=${activeBalanceZone?.description}`
    )

    setTimeout(() => {
      setRouteLocal(`${apiSuffixUrl}/Facturacion/EjecucionFacturacion`)
    }, 1000)
  }

  return (
    <Page>
      <PageHeader title={'Ciclos de facturación'}>
        <ButtonWithPermissions
          variant="contained"
          color="primary"
          size="small"
          hasPermission={hasResource(Resources.Ciclosfacturacionnew)}
          onClick={() => {
            history.push(NonAuthRoutes.invoiceCyclesNew)
          }}
        >
          {t('invoiceCyclesPage:buttons.newInvoiceCycle')}
        </ButtonWithPermissions>
      </PageHeader>
      <CustomIframe
        route={decodeURI(routeLocal)}
        width="100%"
        height="1200"
        allowFullScreen={true}
        button={true}
      />
    </Page>
  )
}
